const removeDeprecatedLocalStorageItems = items => {
  items.forEach(item => {
    const deprecatedItem = JSON.parse(localStorage.getItem(item));
    if (deprecatedItem) localStorage.removeItem(item);
  });
};

export default removeDeprecatedLocalStorageItems;
